import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IPayment } from '../interfaces/ipayment';
import { DatastoreService } from './datastore.service';
import { CommonFunctionsService } from './common-functions.service';
import { ApiService } from './api.service';
import moment from 'moment-timezone';
import { ParamMap } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CapitaService implements IPayment {


  config: any;
  url = 'https://staging.bookinglab.co.uk';
  readonly path;
  readonly paymentType = 'capita';
  private capitaUrlPath = (window.location.hostname.indexOf('staging') !== -1) ? '/payment/' : '/payment/';

  constructor(
    private dataStore: DatastoreService,
    private http: HttpClient,
    private commonFunctionService: CommonFunctionsService,
    private apiService: ApiService
  ) {
    this.path = `/${this.commonFunctionService.getCompanyName()}/${this.commonFunctionService.getCompanyId()}/`;
  }

  async invoke(companyId: number, bookingId: number, purchaseId: number, clientId: number, description: any, fundCode: any, reference: any, price: any, vatOptOut: any) {
    this.config = JSON.parse(this.dataStore.config);
    console.log(this.config);
    if(!fundCode) {
      fundCode = 'MISC';
    }

    let port = '';
    const ports:any = ['80', '443'];
    if(ports.indexOf(window.location.port) === -1) {
      port = `:${window.location.port}`;
    }

    const body = {
      host: `${this.config.host}`,
      company_id: `${companyId}`,
      booking_id: `${bookingId}`,
      purchase_id: `${purchaseId}`,
      client_id: `${clientId}`,
      fund_code: `${fundCode}`,
      description: `${description}`,
      reference: `${reference}`,
      amount: price,
      send_user_details: false, // this adds the billingDetails element to the Capita XML with the card holder name and email pre-populated in the portal
      combine_reference: true,
      add_account_details: true, // This adds the accountName field to the lgItemDetails section of the Capita XML
      vat_opt_out: vatOptOut,
      do_not_store_ref: true,
      return_url: `${window.location.protocol}//${window.location.hostname}${port}${this.path}verify/capita?p=${purchaseId}&b=${bookingId}&c=${companyId}`,
      back_url: `${window.location.protocol}//${window.location.hostname}${port}${this.path}verify/capita?p=${purchaseId}&b=${bookingId}&c=${companyId}`
    }

    try {
      return this.http.post(`${this.url}${this.capitaUrlPath}capita/invoke`, body).toPromise();
    }
    catch (err) {
      throw err;
    }
  }

  async verify(companyId: number, serviceId: number, bookingId: number, purchaseId: number, memberId: number, paymentRef: any, paymentType: string, queryString: ParamMap): Promise<any> {
    this.config = JSON.parse(this.dataStore.config);
    console.log(this.config);
    try {
      const scp:any = await this.query(paymentRef);
      console.log(scp);
      if (scp.state === 'INVALID_REFERENCE') {
        throw new Error('The payment reference is invalid.');
      }
      else {
        if (!scp.ref) {
          if (scp.payment_status) {
            throw new Error('Payment was cancelled.');
          }
          throw new Error('Unable to find payment reference.');
        }
        else {
          let extraItem:any = false;
          let extraItemLink:any = false;
            const extraItemLinkStr = localStorage.getItem('extraItemLink');
            if (extraItemLinkStr && extraItemLinkStr.length > 0) {
              extraItemLink = JSON.parse(extraItemLinkStr) as any;
            }
            const extraItemStr = localStorage.getItem('extraItem');
            if (extraItemStr && extraItemStr.length > 0) {
              extraItem = JSON.parse(extraItemStr) as any;
            }
          if (scp.state ==='COMPLETE') {
            let paymentTypeStr = '';
            switch(paymentType) {
              case "installments":
                paymentTypeStr = 'Ceremony Fee Installment';
                break;
              case 'extra_items':
                paymentTypeStr = 'Optional extra';
                console.log(extraItem);
                if (extraItem) {
                  paymentTypeStr = `${paymentTypeStr} (${extraItem.item_name}) Payment in Full`;
                }
                break;
              default:
                paymentTypeStr = 'Ceremony Fee Outstanding Balance';
            }
            const amount = parseFloat(scp.amount) / 100;
            // update the price of the booking
            const purchase:any = await this.apiService.getPurchase(companyId, serviceId, purchaseId);
            if (paymentType === 'extra_items') {
              await this.apiService.updateBooking({
                price: (parseInt(purchase.price) + parseInt(scp.amount)) 
              }, companyId, bookingId, false);
            }
            // add the payment to the pay API
            await this.apiService.payPurchase(companyId, serviceId, purchaseId, {
              amount: amount,
              transaction_id: `${scp.scp}`,
              notify: false,
              notify_admin: false,
              payment_status: 'paid',
              notes: `${paymentTypeStr}`
            });

            // add extra item
            if (paymentType === 'extra_items') {
              if (extraItemLink.item_id) {
                await this.apiService.linkExtraItem(companyId, serviceId, bookingId, extraItemLink.item_id, extraItemLink.data);
              }
            }

            // add booking note
            let note = `Payment type: ${paymentTypeStr}`;
            note += ` | Deposit? No`;
            if (paymentType === 'extra_items') {
              note += ` | Number of extras: ${extraItemLink.data.quantity}`;
            }
            note += ` | Payment date: ${moment().utc().tz('Europe/London').format("dddd, MMMM Do YYYY")}`;
            note += ` | Payment amount: £${amount}`;
            if (scp.scp) {
                note += ` | Receipt number: ${scp.scp}`;
            }
            note += ` | Payment made through My Ceremony portal`;
            // now update the booking
            const update = await this.apiService.addNotesToBooking(companyId, bookingId, note);
            return update;
          }
          else {
            return await this.verify(companyId, serviceId, bookingId, purchaseId, memberId, paymentRef, paymentType, queryString);
          }
        }
      }
    }
    catch (err) {
      console.error(err);
      throw err;
    }
  }

  async query(paymentRef:any) {
    const body = {
      host: `${this.config.host}`,
      scp_id: paymentRef
    };
    return this.http.post(`${this.url}${this.capitaUrlPath}capita/query`, body).toPromise();
  }
  
  test() {
      console.log(`CAPITA`);
  }
}
